export * from './lib/UiProductInfoCharacteristics';
